import { useMutation } from '@tanstack/react-query';
import { IAsset } from '../Interfaces/Asset/IAsset';
import { IDocument } from '../Interfaces/IDocument';
import { ILegalClient } from '../Interfaces/ILegalClient';
import { ILegalTransactionRelationship } from '../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { customFetcher } from './data';

export type ICreateRelationshipPayload = {
  LegalClientArray: ILegalClient[];
  RelationshipArray: ILegalTransactionRelationship[];
  AssetArray: IAsset[];
  DocumentArray: IDocument[];
  idLegalTransactionType: number;
};

export const useCreateRelationship = () => {
  const { mutateAsync: createRelationship, isPending: isPendingRelationship } =
    useMutation({
      mutationFn: (uploadObject: ICreateRelationshipPayload) =>
        customFetcher({
          endpoint: '/legaltransaction/createRelationship',
          body: uploadObject,
          method: 'POST',
        }),
    });

  return {
    createRelationship,
    isPendingRelationship,
  };
};
